import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { clamp } from '@/lib/depth';

export const HeroContent = () => {
  const indicatorRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      if (indicatorRef.current) {
        indicatorRef.current.style.opacity = String(clamp(1 - window.scrollY / 140, 0, 1));
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="relative h-screen w-screen" data-testid="hero-section">
      <div className="absolute bottom-[14vh] left-[6vw] flex max-w-[88vw] flex-col items-start text-left">
        <motion.h1
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
        style={{ fontFamily: "'IM Fell English', serif" }}
        className="font-medium text-cream text-[12vw] sm:text-[10vw] md:text-[8vw] leading-[0.85]"
        data-testid="hero-name"
      >
        Joe Urbinati
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.7 }}
        className="font-serif italic text-primary/70 text-base sm:text-lg mt-5"
        data-testid="hero-tagline"
      >
        Storyteller. Lawyer. Engineer.
      </motion.p>
      <span
        style={{ fontFamily: "'Space Mono', monospace", fontSize: '10px', letterSpacing: '0.2em', opacity: 0.35, color: 'inherit', marginTop: '16px' }}
      >
        tech × art
      </span>
      </div>
      <div
        ref={indicatorRef}
        className="absolute bottom-[calc(2rem-2vh)] inset-x-0 flex flex-col items-center gap-1.5 text-cream/70"
        data-testid="scroll-indicator"
      >
        <span className="text-[10px] tracking-[0.35em] uppercase">scroll to explore</span>
        <ChevronDown className="h-4 w-4 animate-chevron" />
      </div>
    </div>
  );
};
